var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageBelow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_712_3452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 0.75H0.75C0.336 0.75 0 1.086 0 1.5C0 1.914 0.336 2.25 0.75 2.25H23.25C23.664 2.25 24 1.914 24 1.5C24 1.086 23.664 0.75 23.25 0.75Z",
    fill: "#CCA3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 4.25H0.75C0.336 4.25 0 4.586 0 5C0 5.414 0.336 5.75 0.75 5.75H23.25C23.664 5.75 24 5.414 24 5C24 4.586 23.664 4.25 23.25 4.25Z",
    fill: "#CCA3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 7.75H0.75C0.336 7.75 0 8.086 0 8.5C0 8.914 0.336 9.25 0.75 9.25H23.25C23.664 9.25 24 8.914 24 8.5C24 8.086 23.664 7.75 23.25 7.75Z",
    fill: "#CCA3CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11.25H1.75C0.79 11.25 0 12.04 0 13V24.5C0 25.46 0.79 26.25 1.75 26.25H22.25C23.21 26.25 24 25.46 24 24.5V13C24 12.04 23.21 11.25 22.25 11.25ZM1.5 13C1.5 12.86 1.61 12.75 1.75 12.75H22.25C22.39 12.75 22.5 12.86 22.5 13V17.74L20.2 15.69C19.52 15.08 18.47 15.11 17.8 15.76L12.2 21.37L11.88 21.43C11.86 21.42 11.84 21.41 11.82 21.39L8.21 17.78C7.54 17.11 6.47 17.09 5.78 17.73L1.5 21.69V13Z",
    fill: "#99439D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_712_3452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25.5,
    fill: "white",
    transform: "translate(0 0.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageBelow);
export default __webpack_public_path__ + "static/media/ImageBelow.cb21a5f207e17d1afe2799593a4a77e0.svg";
export { ForwardRef as ReactComponent };